import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as L from 'leaflet';
L.Icon.Default.imagePath = 'assets/leaflet/';


import * as Sentry from "@sentry/angular";
import {environment} from './environments/environment';
import packageJson from '../package.json';

// ✅ Обробка unhandled відмов промісів
window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason);
});

// ✅ Обробка глобальних помилок (іноді Zone.js не все ловить)
window.addEventListener('error', (event) => {
  Sentry.captureException(event.error ?? event.message);
});


Sentry.init({
  dsn: "https://189c77a55fe15c8bf09cd05dc847e10b@sentry.megakit.pro/22",
  release: packageJson.version,
  tracesSampleRate: environment.production ? 0.1 : 1.0,
  environment: environment.production ? 'production' : 'development',
  sendDefaultPii: true
});


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
